module.exports = __webpack_public_path__ + "b14d98320f6a16fcbd881f6e8e8ade1b.png";